@if (!hidden) {
<div class="map-draw-container">
    @for (group of groups; track group.id) {
    @if (!group.hideInDrawMenu) {

    <rask-toggle-panel class="list" size="4" [label]="group.title"
        [defaultExpanded]="isGroupExpanded(group)"
        (onToggle)="onGroupToggle(group, $event)">
        @for (option of group.drawOptions; track option.title) {
        <div>
            <rask-button class="list-menu"
                (click)="optionClick(group.optionTargetLayer, option)" color="tertiary" [disabled]="isDrawing"
                [icon]="option.drawMenuIcon">
                {{option.title}}
            </rask-button>
            @if (mapEditService.canPasteFromInternal()) {
            <rask-button class="list-menu"
                (click)="paste(group.optionTargetLayer, option)" color="tertiary"
                [disabled]="isDrawing">
                Klistra in från urklipp
            </rask-button>
            }
        </div>
        }
        @for (item of group.items; track item.label + i; let i = $index) {
        <rask-button class="list-menu neutral"
            (click)="click(item.layer, item.geometry, $event)"
            (mouseover)="mouseover(item.layer, item.geometry, $event)"
            (mouseout)="mouseout(item.layer, item.geometry, $event)"
            color="tertiary"
            [disabled]="isDrawing">{{displayCounter(group, i)}} {{item.label}}</rask-button>
        }
    </rask-toggle-panel>
    }
    }
    @for (media of mediaLayers; track media.id) {
    <rask-toggle-panel class="list" size="4" [label]="media.title">
        @for (n of media.mediaOptions; track n.id) {
        <div (click)="n.callback()">
            @if (n.selectable) {
            <rask-checkbox class="low" [(ngModel)]="n.selected"
                [text]="n.title">
            </rask-checkbox>
            } @else {
            <rask-button class="list-menu" color="tertiary">{{ n.title }}</rask-button>
            }
        </div>
        }
    </rask-toggle-panel>
    }
</div>
}